import { defineStore } from "pinia"
import { MenuItemService } from "@/store/services/menuItem.service.js"
import { storeToRefs } from "pinia"

export const menuItemStore = defineStore("menuItem", {
  state: () => {
    return {
      menuItems: "",
    }
  },
  getters: {
    getMenuItems: (state) => state.menuItems,
  },
  actions: {
    getMenuItemsAction() {
      if (this.menuItems != "") return this.menuItems
      EventSys.$emit("menuItems_loading")
      MenuItemService.list().then(({ data }) => {
        EventSys.$emit("menuItems_loaded")
        this.menuItems = data
      })
    },
  },
})
